import React, { useState } from "react";
import Button from "../../components/Button";
import Loading from "../../components/Loading";
import { submit } from "../../actions/studensts";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import TermsAndConditions from "./terms-and-conditions";
import { Container } from "react-bootstrap";

const studentInitialData = {
  id: "",
  full_name: "",
  email: "",
  phone: "",
  submit_date: formatDate(new Date(Date.now())),
  citizenship: "egyptian",      // NEW
  date_of_birth: "",            // NEW (only for foreign)
};

export default function Form() {
  const [studentData, setStudentData] = useState(studentInitialData);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const date = formatDate(new Date(Date.now()));

    // Build payload and drop date_of_birth unless foreign
    const payload = { ...studentData };
    if (payload.citizenship !== "foreign") {
      delete payload.date_of_birth;
    }

    const res = await submit(payload, date);
    console.log(res);
    setLoading(false);
    if (res !== 201) {
      navigate("/redirect", { state: { request: "bad" } });
    } else {
      navigate("/redirect", { state: { request: "good" } });
    }
  };

  const handleInputChange = (e) => {
    const target = e.target;
    const name = target.name;
    let value;

    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "number") {
      const int_value = parseInt(target.value, 10);
      value = isNaN(int_value) ? 0 : int_value;
    } else {
      value = target.value;
    }

    // Block Arabic characters in National ID field
    if (name === "id" && studentData.citizenship === "egyptian") {
      // Remove Arabic letters (U+0600 to U+06FF, U+0750 to U+077F, U+08A0 to U+08FF)
      // and Arabic-Indic digits (U+0660 to U+0669)
      value = value.replace(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/g, '');
    }

    // Clear date_of_birth when switching away from foreign
    if (name === "citizenship") {
      setStudentData((prev) => ({
        ...prev,
        citizenship: value,
        date_of_birth: value === "foreign" ? prev.date_of_birth : "",
      }));
      return;
    }

    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Container className="flex justify-center items-center">
      <form
        onSubmit={handleSubmit}
        action="submit"
        className="flex flex-col lg:w-3/4 md:w-3/4 w-full p-7 my-2 lg:shadow 
            bg-white bg-opacity-90 lg:border-none sm:rounded-none md:border md:rounded-lg"
      >
        <p className="font-bold text-center">
          <span className="text-red-700">Note:</span>
          <br />
          For Best Experience We Recommend to
          <br />
          Use Google Chrome or Firefox Browsers,
          <br />
          and if you use an Apple Product, Please
          <br />
          Make Sure that Safari Version is 12.0 or Higher.
        </p>
        <p
          className="font-bold text-center text-red-700 text-lg md:text-xl bg-yellow-100 border border-red-300 rounded-lg p-3 my-2"
          dir="rtl"
        >
          الفورم ليست حجز لاجراءات التوثيق و لبدأ التوثيق يجب زيارة مقر الشركة
          <br />
          لمعرفة المواعيد يرجى زيارة صفحة الـ Facebook
        </p>
        <div className="border-b m-2">
          <label htmlFor="form" className="text-xl font-bold">
            Add Your Information
          </label>
        </div>

        <Input
          type="text"
          placeholder="Full Name"
          name="full_name"
          onChange={handleInputChange}
          value={studentData.full_name}
          pattern="^[a-zA-Z0-9\\-\\u0590-\\u05FF ]+$"
          title="Please enter english language only"
        />

        {/* Citizenship selector */}
        <div className="m-2 flex items-center justify-center">
          <label htmlFor="citizenship" className="flex-auto">
            <span className="text-red-600">*</span> Nationality:
          </label>
          <select
            id="citizenship"
            name="citizenship"
            value={studentData.citizenship}
            onChange={handleInputChange}
            className="flex flex-col md:w-1/3  p-2 my-2 lg:shadow 
 bg-white bg-opacity-90 lg:border-none sm:rounded-none md:border md:rounded-lg mt-1 border rounded-xl focus:outline-blue-700"
          >
            <option value="egyptian">Egyptian</option>
            <option value="foreign">Foreign (Non-Egyptian) </option>
          </select>
        </div>

   

        {/* date_of_birth only for foreign */}
        {studentData.citizenship === "foreign" && (
          <>
        <Input
          type="text"
          placeholder="Passport Number"
          name="id"
          onChange={handleInputChange}
          value={studentData.id}
        />
          <Input
            type="date"
            placeholder="Birth Date"
            name="date_of_birth"
            value={studentData.date_of_birth}
            onChange={handleInputChange}
            required
          />
                <p className="font-bold text-center">
          <span className="text-red-500">Important: Please, make sure that you entered Birth Date as appears on your Passport </span>
        </p>
          </>
              
        )}
      {studentData.citizenship === "egyptian" && (
          <>
        <Input
          type="text"
          placeholder="National ID "
          name="id"
          onChange={handleInputChange}
          value={studentData.id}
          pattern="^[a-zA-Z0-9]+$"
          title="Please enter English letters and numbers only (no Arabic characters)"
        />
          </>
              
        )}

        <Input
          type="email"
          placeholder="Email"
          name="email"
          onChange={handleInputChange}
          value={studentData.email}
        />
        <Input
          type="number"
          placeholder="Phone"
          name="phone"
          onChange={handleInputChange}
          value={studentData.phone}
        />

        <div className="m-2 mt-3 flex items-center justify-center text-right">
          <input
            autoComplete="off"
            type="checkbox"
            className="flex-initial p-2 ml-1 border rounded-xl focus:outline-blue-700"
            required={true}
          />
          <label htmlFor="send score" className="flex-auto dir-pthree">
            <span className="text-red-600 ">*</span>
            <span className="text-base font-medium">نرجوا التاكد من عمل </span>
            <span>
              <a
                className="text-blue-700 underline"
                href="https://www.act.org/content/act/en/products-and-services/the-act/scores/sending-your-scores.html"
                target="_blank"
                rel="noreferrer"
              >
                Send score
              </a>
            </span>
            <span className="text-base font-medium">
              &nbsp;للمحاولات المطلوبة&nbsp;
            </span>
          </label>
        </div>

        <div>
          <TermsAndConditions />
          <div>
            <Input type="text" placeholder="Printed Full Name" />
            <Input
              type="date"
              placeholder="Today's Date"
              name="submit_date"
              value={studentData.submit_date}
              onChange={handleInputChange}
            />
            {/* <Input type="date" placeholder="Today's Date" /> */}
            <Input type="text" placeholder="Signature" />
            <Input type="text" placeholder="Egyptian ID Number" required={false} />
            <Input type="text" placeholder="Passport Number" required={false} />
          </div>
        </div>

        <div className="flex flex-row-reverse items-center justify-between mt-3 pt-2">
          <Button
            type="submit"
            color="bg-green-700 disabled:bg-gray-300"
            disabled={loading}
            text={!loading ? "Submit" : <Loading />}
          />
        </div>
        <span className="text-red-700 text-sm">*required field</span>
      </form>
    </Container>
  );
}

function formatDate(today) {
  return today?.toISOString().split("T")[0];
}